import * as React from "react";
import type { SVGProps } from "react";
const SvgDollarCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={81}
    height={80}
    fill="none"
    {...props}
  >
    <path
      fill="#79AFFF"
      d="M40.763 73c18.41 0 33.333-14.924 33.333-33.333 0-18.41-14.924-33.334-33.333-33.334-18.41 0-33.333 14.924-33.333 33.334C7.43 58.077 22.354 73 40.763 73Z"
      opacity={0.4}
    />
    <path
      fill="#79AFFF"
      d="m48.296 40-5.034-1.767v-11.3h1.2c2.7 0 4.9 2.367 4.9 5.267 0 1.367 1.134 2.5 2.5 2.5 1.367 0 2.5-1.133 2.5-2.5 0-5.667-4.433-10.267-9.9-10.267h-1.2V20c0-1.367-1.133-2.5-2.5-2.5a2.518 2.518 0 0 0-2.5 2.5v1.933h-2.166c-4.934 0-8.967 4.167-8.967 9.267 0 5.967 3.467 7.867 6.1 8.8l5.033 1.767v11.266h-1.2c-2.7 0-4.9-2.366-4.9-5.266 0-1.367-1.133-2.5-2.5-2.5a2.518 2.518 0 0 0-2.5 2.5c0 5.666 4.434 10.266 9.9 10.266h1.2V60c0 1.367 1.134 2.5 2.5 2.5 1.367 0 2.5-1.133 2.5-2.5v-1.933h2.167c4.933 0 8.967-4.167 8.967-9.267-.034-6-3.5-7.9-6.1-8.8Zm-13.4-4.7c-1.7-.6-2.734-1.167-2.734-4.067 0-2.366 1.767-4.266 3.967-4.266h2.167V36.5l-3.4-1.2Zm10.533 17.767h-2.167v-9.534L46.63 44.7c1.7.6 2.733 1.167 2.733 4.067 0 2.366-1.766 4.3-3.933 4.3Z"
    />
  </svg>
);
export default SvgDollarCircle;
